module.exports = __webpack_public_path__ + "static/img/ai.8d1befca.png";